<template>
  <div class="auto-comp-browser p-2">
    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <div v-if="!loading && !loadingError">
      <div class="row no-gutters">
        <div class="col-10">
          <FormRow label="Search">
            <FormInputText v-model="searchText" placeholder="Search Components" />
          </FormRow>
        </div>
      </div>

      <div v-for="(moduleInfo, index) of filteredComponentModules" :key="`${moduleInfo.name}-${index}`" class="py-2">
        <ContentTitle>{{moduleInfo.name}}</ContentTitle>
        <div class="row no-gutters">
          <div class="col-6" v-for="componentType of moduleInfo.componentList" :key="componentType.id">
            <AutomationComponentType :autoComponentType="componentType" @click="componentTypeClicked(componentType)" />
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import formMixin from '@/mixins/form'

import AutomationComponentType from '@/modules/automations/components/automationComponentType'

export default {
  name: 'AutomationComponentTypeBrowser',
  mixins: [formMixin],
  components: {
    AutomationComponentType
  },
  props: {
    requiredTypes: Array
  },
  data() {
    return {
      loading: true,
      loadingError: '',
      searchText: '',
      componentTypeList: []
    }
  },
  computed: {
    filteredComponentModules() {
      var moduleList = []
      this.filteredComponentList.forEach(component => {
        let module = moduleList.find(moduleInfo => moduleInfo.name == component.module)
        if(module) {
          module.componentList.push(component)
        } else {
          moduleList.push({
            name: component.module,
            componentList: [component]
          })
        }
      })

      return moduleList
    },
    filteredComponentList() {
      let search = ('' + this.searchText).trim().toLowerCase()
      if(search != '') {
        return this.componentTypeList.filter(componentType => componentType.name.toLowerCase().includes(search))
      }
      return this.componentTypeList
    }
  },
  mounted() {
    this.requestData()
  },
  methods: {
    requestData() {
      this.loading = true
      this.loadingError = ''

      var params = {
        filter: {}
      }
      if(this.requiredTypes && this.requiredTypes.length > 0)
        params.filter.type = this.requiredTypes.join(', ')
      
      this.$apiService.automationService.getComponentTypeList(params)
      .then(response => {
        this.componentTypeList = response.data
      })
      .catch(err => {
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    },
    componentTypeClicked(componentType) {
      this.$emit('componentClicked', componentType.id)
    }
  }
}
</script>